import Vue from 'vue/dist/vue.esm'
import MainNav from '../components/layouts/MainNav.vue'
import PostsIndex from '../components/PostsIndex.vue'
import PostsSort from '../components/PostsSort.vue'
import PagesIndex from '../components/PagesIndex.vue'

// Vue.component('main-nav', MainNav)
Vue.component('post-index', PostsIndex)
Vue.component('page-index', PagesIndex)
Vue.component('post-sort', PostsSort)